import {
    Crown,
    Zap,
    Headset,
    Wrench,
    Building, ThumbsUp, Award, CheckCircle
} from 'lucide-react';
import ChimneymainImg from '../img/hob-about-img-main.png';
import CTA from './Cta';

function AboutUs() {
    return (
        <>
            <section className="hob-about-hero">
                <div className="hob-about-hero-content">
                    <h1 className="hob-about-title">Welcome to Royal Ambulance</h1>
                    <p className="hob-about-subtitle">
                       The right team for the toughest moments.
                    </p>
                </div>
            </section>

            <section className="hob-aboutus-section">
                <div className="hob-aboutus-container">
                    <div className="hob-aboutus-left">
                        <p className="hob-aboutus-text">
                            Royal Ambulance is a trusted name in home appliance repair, focused on restoring
                            convenience and functionality in modern kitchens.
                        </p>
                        <p className="hob-aboutus-text">
                            From chimney servicing to built-in oven repairs, we ensure precision and
                            reliability in every task we handle.
                        </p>
                        <p className="hob-aboutus-text">
                            Founded with a passion for service excellence, our journey began with a single goal:
                            to elevate the standard of home maintenance and support.
                        </p>
                        <p className="hob-aboutus-subtext">
                            Today, we operate with a team of highly trained paramedics using state-of-the-art ICU equipment and advanced patient monitoring systems, ensuring your loved ones receive the highest standard of safety during transit.
                        </p>
                        <p className="hob-aboutus-subtext">
                            We value clear communication, compassion, and rapid response times. At Royal Ambulance, premium care isn’t optional—it’s our promise.
                        </p>
                    </div>

                    <div className="hob-aboutus-right">
                        <div className="hob-aboutus-image-wrapper">
                            <img
                                src={ChimneymainImg}
                                alt="Our Team"
                                className="hob-aboutus-image"
                            />

                            <div className="hob-aboutus-float hob-aboutus-top-right">
                                <div className="hob-aboutus-flex">
                                    <Building size={18} />
                                    <span>Since 2010</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Over 10 years of premium ambulance services.
                                </p>
                            </div>

                            <div className="hob-aboutus-float hob-aboutus-bottom-right">
                                <div className="hob-aboutus-flex">
                                    <ThumbsUp size={18} />
                                    <span>10K+ Users</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Trusted by thousands of satisfied users.
                                </p>
                            </div>

                            <div className="hob-aboutus-float hob-aboutus-center-float">
                                <div className="hob-aboutus-flex">
                                    <Award size={18} />
                                    <span>Top-rated Repairs</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Industry leaders in ambulance services.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 3: Values */}
            <section className="hob-about-values">
                <div className="hob-about-values-grid">
                    <div className="hob-about-value-card">
                        <Crown size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">Premium Medical Care</h3>
                        <p className="hob-about-value-text">Top-tier critical care with a steadfast commitment to patient safety</p>
                    </div>
                    <div className="hob-about-value-card">
                        <Zap size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">Rapid Response</h3>
                        <p className="hob-about-value-text">Immediate dispatch and trusted transport when every second counts.</p>
                    </div>
                    <div className="hob-about-value-card">

                        <Headset size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">24/7 Emergency Support</h3>
                        <p className="hob-about-value-text">We are ready to deploy day or night, whenever you need a lifeline.</p>
                    </div>
                    <div className="hob-about-value-card">

                        <Wrench size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">Medical Experts</h3>
                        <p className="hob-about-value-text">Certified paramedics equipped with state-of-the-art ICU technology.</p>
                    </div>
                </div>
            </section>

            <CTA />
        </>
    );
}

export default AboutUs;
